// 登录页

// 扫码实体商家付款登陆页面
const loginShop = resolve => require(['../view/login/loginShop'], resolve)
// 扫码实体商家付款注册页面
const registShop = resolve => require(['../view/login/registShop'], resolve)
//登陆页面
const login = resolve => require(['../view/login/login'], resolve)
// 注册
const regist = resolve => require(['../view/login/regist'], resolve)
// 详情页分享链接进入注册
const NewRegist = resolve => require(['../view/login/NewRegist'], resolve)
// 忘记密码
const Forget = resolve => require(['../view/login/forget'], resolve)


const routes = [
  {
    path: '/login',
    name: 'login',
    component: login,
    meta: {
      // requireAuth: true
    }
  },
  {
    path: '/registShop',
    name: 'registShop',
    component: registShop,
    meta: {
      // requireAuth: true
    }
  },
  {
    path: '/loginShop',
    name: 'loginShop',
    component: loginShop,
    meta: {
      // requireAuth: true
    }
  },
  {
    path: '/regist',
    name: 'regist',
    component: regist,
    meta: {
      // requireAuth: true
    }
  },
  {
    path: '/NewRegist',
    name: 'NewRegist',
    component: NewRegist,
    meta: {
      // requireAuth: true
    }
  },
  {
    path: '/Forget',
    name: 'Forget',
    component: Forget,
    meta: {
      // requireAuth: true
    }
  }
]
export default {
  routes
}



// WEBPACK FOOTER //
// ./src/router/login.js